import { Box, Drawer } from '@mui/material';
import { bool, object } from 'prop-types';
import React from 'react';
import CloseButton from '../CloseButton';

import connector from './connector';
import AppForm from './Form';

const AppDrawer = ({ actions, isOpen }) => (
  <Drawer anchor="right" open={isOpen} onClose={actions.drawers.app.close}>
    <Box
      sx={theme => ({
        display: 'flex',
        width: '100%',
        [theme.breakpoints.up('md')]: {
          width: 1000,
        },
      })}
    >
      <Box sx={{ paddingTop: '20px', paddingLeft: '20px' }}>
        <CloseButton onClick={actions.drawers.app.close} />
      </Box>
      <AppForm />
    </Box>
  </Drawer>
);

AppDrawer.propTypes = {
  actions: object.isRequired,
  isOpen: bool.isRequired,
};

export default connector(AppDrawer);
